import { Button } from '@eb/eds-button';
import { Icon } from '@eb/eds-icon';
import { MagnifyingGlassChunky } from '@eb/eds-iconography';
import { InputField } from '@eb/eds-input-field';
import { gettext } from '@eb/i18n';
import loadable from '@loadable/component';
import React, { FunctionComponent } from 'react';
import { SettingsContext } from '../../context';
import { AppProps } from '../../types';
import { dynaMount } from '../utils/mountComponent';
import './SearchTakeoverRoot.scss';

const LazySearchTakeover = loadable.lib(() => import('@eb/search-takeover'));

interface SearchTakeoverProps {
    domNodeId: string;
    onClose: () => void;
    id: string;
    isVisible: boolean;
}

const SearchTakeoverController: React.FunctionComponent = () => {
    const [
        isSearchTakeoverVisible,
        setIsSearchTakeoverVisible,
    ] = React.useState<null | boolean>(null);

    return (
        <>
            <Button
                onClick={() => setIsSearchTakeoverVisible(true)}
                style="none"
                size="block"
                __containerClassName="listings__search-takeover__trigger eds-show-up-md"
            >
                <InputField
                    disabled={true}
                    style="basic"
                    id="search-autocomplete"
                    type="search"
                    value=""
                    placeholder={gettext('Search for events')}
                    label="Trigger search event experience"
                    prefix={
                        <Icon
                            type={<MagnifyingGlassChunky />}
                            size="small"
                            color="grey-500"
                        />
                    }
                    bottomSpacing={0}
                />
            </Button>
            <Button
                style="none"
                onClick={() => setIsSearchTakeoverVisible(true)}
                __containerClassName="listings__search-takeover__trigger eds-show-down-mn"
            >
                <Icon
                    type={<MagnifyingGlassChunky />}
                    size="small"
                    color="grey-700"
                />
            </Button>

            {isSearchTakeoverVisible !== null ? (
                <LazySearchTakeover>
                    {({
                        SearchTakeover,
                    }: {
                        SearchTakeover: FunctionComponent<SearchTakeoverProps>;
                    }) => (
                        <SearchTakeover
                            domNodeId="listings-root"
                            onClose={() => setIsSearchTakeoverVisible(false)}
                            id="search-takeover"
                            isVisible={isSearchTakeoverVisible}
                        />
                    )}
                </LazySearchTakeover>
            ) : null}
        </>
    );
};

const SearchTakeoverControllerRootMount: React.FunctionComponent<AppProps> = (
    props,
) =>
    dynaMount(
        {
            Component: SearchTakeoverController,
            containerId: 'listings__root__search-takeover',
        },
        props,
    );

export const SearchTakeoverRoot = (props: AppProps) => {
    const {
        featureFlags: { launchSearchTakeoverOnListings = false } = {},
    } = React.useContext(SettingsContext);

    if (!launchSearchTakeoverOnListings) {
        return null;
    }

    return (
        <>
            <SearchTakeoverControllerRootMount {...props} />
        </>
    );
};
